import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { utilityProvidersRoutes } from './routes';
export class UtilityProviders {
  constructor() {
    _defineProperty(this, "routes", utilityProvidersRoutes);
  }
  async searchUtilityProviders(data, options) {
    const resp = await requestService('property').get(this.routes.baseUrl, _objectSpread({
      params: {
        Search: data.searchKey
      }
    }, options.cancelToken));
    return resp.data;
  }
  async addUtilityProviders(data, options) {
    const resp = await requestService('property').post(this.routes.baseUrl, _objectSpread(_objectSpread({}, data), options.cancelToken));
    return resp.data;
  }
  async addUtilityProvidersV2(data, options) {
    const resp = await requestService('property').post(this.routes.baseUrlV2, _objectSpread(_objectSpread({}, data), options.cancelToken));
    return resp.data;
  }
  async editUtilityProviders(data, options) {
    const resp = await requestService('property').put(this.routes.providerId(data.providerId), _objectSpread(_objectSpread({}, data), options.cancelToken));
    return resp.data;
  }
  async getAllUtilityTypes(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data, options) {
    const resp = await requestService('property').get(this.routes.utility, _objectSpread(_objectSpread({}, data), options.cancelToken));
    return resp.data;
  }
  async getUtilityProvider(data, options) {
    const resp = await requestService('property').get(this.routes.providerId(data.utilityProviderId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getUtilityProvidersList(data, options) {
    const resp = await requestService('property').post(this.routes.providersList, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updateUtilityProvider(data, options) {
    const resp = await requestService('property').put(this.routes.providerId(data.utilityProviderId), _objectSpread(_objectSpread({}, data), options.cancelToken));
    return resp.data;
  }
  async getUtilityInfo(data, options) {
    const resp = await requestService('property').post(this.routes.getUtilityInfo, _objectSpread(_objectSpread({}, data), options.cancelToken));
    return resp.data;
  }
  async postCustomUtilityType(data, options) {
    const resp = await requestService('property').post(this.routes.utility, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async putCustomUtilityType(data, options) {
    const resp = await requestService('property').put(this.routes.utility, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postCustomUtilityTypeAndAttach(data, options) {
    const resp = await requestService('property').post(this.routes.utilityToProvider(data.utilityProviderId), _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}